export class InwardFilterReq{
    fromDate?:string
    toDate?:string
    supplierId?:number
    inwardId?:number
    voucherNo?:string
    inwardType?:string
    productId?:number
}

export class VoucherVendorReq{
    vendorId?:number
}

export class InvoiceNumReq{
    invNo?:string
    fromDate?:string
    toDate?:string
}

export class CreateInvoiceForVoucher{
    invoiceNo: string;
    invoiceDate: Date;
    grnIds: number[];
    vendorId: number;
}

export class VoucherReq{
    vendorId?:number
}